import { createFileRoute } from "@tanstack/react-router";
import { OverduePaymentRedirectPage } from "@/pages/subscription-setup";

export const Route = createFileRoute(
  "/_authed/_noSidebar/$companySlug/subscribe/overdue",
)({
  component: OverduePaymentRedirectPage,
});
